import { useLogin } from '@/providers/login/LoginProvider';
import React from 'react';
import { ContactDetailsForm } from '@/components/SummaryContactDetails/ContactDetailsForm';

export const RecognizeUserForm = ({
  data,
  onBlur,
  showErrors,
  isActive,
  isActiveLoading,
  disabledEmail,
  formFields,
}) => {
  const { isPrime, isLogged } = useLogin();

  const createValidationWrapper = (validationFn) => {
    return (value = '') => {
      const isValidBase = validationFn(value);

      if (isActiveLoading) {
        return true;
      } else {
        return (
          (isValidBase && isActive) || (isValidBase && isLogged && isPrime)
        );
      }
    };
  };
  return (
    <ContactDetailsForm
      data={data}
      onBlur={onBlur}
      showErrors={showErrors}
      emailDisabled={Boolean(disabledEmail)}
      emailValidation={createValidationWrapper(formFields.EMAIL.validation)}
      formDisabled={!isActive && !isLogged}
      formFields={formFields}
    />
  );
};
